import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { accountApi } from '../../services/accountApi';
import { ForgotPasswordRequest } from '../../dtos/Accounts/index';

export function useForgotPassword() {
  return useMutation({
    mutationFn: (request: ForgotPasswordRequest) => accountApi.forgotPassword(request),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Email de resetare a parolei a fost trimis. Verificați inbox-ul dumneavoastră.');
      } else {
        toast.error(`Eroare: ${response.errorMessage || 'Nu s-a putut trimite email-ul de resetare'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Eroare: ${error.message || 'Nu s-a putut trimite email-ul de resetare'}`);
    },
  });
}
